import styles from "./runLoadTestModal.module.scss";
import { useTranslation } from "react-i18next";
import ReactDOM from "react-dom";
import {
  useEffect,
  useMemo,
  useRef,
  useState
} from "react";
import { CSSTransition } from "react-transition-group";
import okIcon from "../../shared/images/ok.svg";
import errorIcon from "../../shared/images/error.svg";
import watchIcon from "../../shared/images/watch.svg";
import { ReactComponent as CloseIcon } from "../../shared/images/close.svg";
import { ErrorType } from "../../types/sharedTypes";
import gearSpinnerIcon from "../../shared/images/gearSpinner.svg";

type RunLoadTestModalProps = {
  isShow: boolean;
  isLoading: boolean;
  errorData: ErrorType;
  closeModal: () => void;
}

export const RunLoadTestModal = ({ isShow, isLoading, errorData, closeModal }: RunLoadTestModalProps) => {
  const { t } = useTranslation();

  const containerRef = useRef<HTMLDivElement>( null);

  const [isShowLocal, setIsShowLocal] = useState<boolean>(isShow);

  useEffect(() => {
    setIsShowLocal(isShow);
  }, [isShow]);

  const closeModalLocal = (): void => {
    closeModal();
  }

  const description: string = useMemo(() => {
    if (isLoading) {
      return t("common.loading");
    } else {
      if (!!errorData) {
        if (errorData.status === 409) {
          return t("loadTestSettings.testAlready");
        } else if (errorData.status === 403) {
          setIsShowLocal(false);
          return "";
        } else {
          return t("loadTestSettings.testFailed");
        }
      } else {
        return t("loadTestSettings.testStarted");
      }
    }
  }, [isLoading, errorData]);

  const srcIcon = useMemo(() => {
    if (isLoading) {
      return gearSpinnerIcon;
    } else {
      if (!!errorData) {
        if (errorData.status === 409) {
          return watchIcon;
        } else {
          return errorIcon;
        }
      } else {
        return okIcon;
      }
    }
  }, [isLoading, errorData]);

  return ReactDOM.createPortal(
    <CSSTransition in={isShowLocal} timeout={300} unmountOnExit nodeRef={containerRef} classNames={{
      enter: styles.enter,
      exit: styles.exit,
      enterActive: styles.enterActive,
      exitActive: styles.exitActive,
    }}>
      <div className={styles.container} ref={containerRef}>
        <div className={styles.message}>
          <img src={srcIcon} alt=""/>
          {description}
        </div>
        <CloseIcon onClick={closeModalLocal}/>
      </div>
    </CSSTransition>,
    document.body
  )
}